import './sectionOurGames.scss';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

export default (() => {
	$(document).ready(function () {
		$('.our-games__slider').owlCarousel({
			items: 1,
			loop: true,
			center: true,
			dots: true,
			nav: false,
			margin: -50,
			stagePadding: 25,
			responsive: {
				480: {
					stagePadding: 50
				},
				768: {
					items: 3,
					nav: false,
					margin: 15,
					stagePadding: 0
				},
				992: {
					items: 3,
					nav: true,
					margin: 15,
					stagePadding: 0
				}
			}
		});
	});

	if ($('.section--our-games').length > 0) {
		const controller = new ScrollMagic.Controller();
		const section = document.querySelector('.section--our-games');
		const title = section.querySelector('.title');

		let games = section.querySelectorAll('.our-games__item');

		new ScrollMagic.Scene({
			triggerElement: title,
			triggerHook: '1'
		})
			.setTween(title, 1, {
				y: 0,
				opacity: 1,
				onComplete: () => {
					title.classList.add('title--completed');
				}
			})
			.on('leave', e => {
				title.classList.remove('title--completed');
			})
			.addTo(controller);

		new ScrollMagic.Scene({
			triggerElement: games,
			triggerHook: '1'
		})
			.on('enter', e => {
				let index = 0;
				Array.prototype.forEach.call(games, function (game) {
					$(game).css({
						animation: `fade-down 1s linear ${0.1 + index * 0.2}s forwards`
					});
					index++;
				});
				$(section.querySelector('.button')).css({
					animation: 'fade-down .25s linear forwards'
				});
			})
			.on('leave', e => {
				Array.prototype.forEach.call(games, function (game) {
					$(game).css({
						animation: ''
					});
				});
				$(section.querySelector('.button')).css({
					animation: ''
				});
			})
			.addTo(controller);

		if ($('.game-main-page').length > 0 && $('.our-games .button').length > 0) {
			if (current_page === max_page) $('.our-games .button').css('display', 'none');
			document.querySelector('.our-games .button').onclick = function (e) {
				const container = document.querySelector('.our-games .row');
				e.preventDefault();
				var gamesData = {
					action: 'loadmore_games',
					query: gamesQuery,
					page: current_page,
					maxPage: max_page
				};
				if (current_page > 0) {
					$.ajax({
						url: ajaxurl,
						data: gamesData,
						type: 'POST',
						beforeSend: function (xhr) {
							$(e.target).attr('disabled');
						},
						success: function (data) {
							if (data) {
								$(container).append(data);
								current_page++;
								$(e.target).removeAttr('disabled');
								games = document.querySelectorAll('.our-games__item');
								if (current_page === gamesData.maxPage) $(e.target).css('display', 'none');
							}
						}
					});
				}
			};
		}
	}
})();
